export default __webpack_public_path__ + "static/media/spacing-horizontal.9a94de4f.svg";